import { Component, OnInit, Inject, DOCUMENT, input } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ContextService } from '../context.service';
import { SubstitutionPipe } from '../substitution.pipe';

import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'mutara-instructions',
  templateUrl: './instructions.component.html',
  standalone: false
})
export class InstructionsComponent implements OnInit {
  readonly currentLink = input<SafeHtml>('');
  substitutionValues: any;
  markdownData: string = '';
  constructor(private context: ContextService,
    @Inject(DOCUMENT) private hostDocument: any,
    private http: HttpClient,
    private defaultPipe: SubstitutionPipe) {
  }
  /**
   * Ensure we get the server url if it is included in the link
   */
  ngOnInit(): void {
    this.substitutionValues = Object.assign({ "ui-host": this.hostDocument.location.origin }, this.context.config?.info, this.context.config?.defaults);
    this.context.subscribeTo("instructionsLink", (instructions: string) => {
      this.currentLink.apply(instructions);

      this.http.get(instructions, {responseType:'text'}).subscribe({
        error: (err) => {
          if ( err.status != 304 ) {
            console.error('Failed to get Markdown %O', err);
          } else {
            console.log('Re-using existing instruction file');
          }
        },
        next: (result) => {
          this.markdownData = <string>this.defaultPipe.transform(result, this.substitutionValues);
           //console.log('Markdown Instructions: %O\n  %O', this.currentLink, this.markdownData);
        }
      })
    });
  }

  jumpTo(anchorName: string) {
    console.log('jump to ' + anchorName);
  }
  onError(event: string ) {
    console.log(event);
  }
}